function getLoggedInUser() {
    return null;
}

function getLoggedInState() {
    return {
        isLoggedIn: false,
    };
}

function logOut() {}

export default {
    getLoggedInState,
    getLoggedInUser,
    logOut,
};
